import axios from "axios";
import APILinks from "@/links/links";

export default {
  getToken(roomName, participantName) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.get(
      APILinks.LIVEKIT_GET_TOKEN() + `?room_name=${roomName}&participant_name=${participantName}`,
      { headers: headers }
    );
  },
};
